import * as Utils from '../utils/util';
import * as Toolkit from '../toolkit/index';
import { __dataGet__, __allDataGet__, __hasKey__, __depGet__, __hasCube__, __allCube__ } from './db';

export function getValue(cubeId: string, key: string): any {
    return __dataGet__(cubeId, key);
}

export const getNumberValue = Utils.createComposeFunc(Utils.toNumberForce, Utils.toNumber, getValue);

const pxSize = Utils.createComposeFunc(Toolkit.cmToPx, Utils.toNumberForce, Utils.toNumber, getValue);

export function getLogicValue(cubeId: CubeId, key: string): number {
    return pxSize(cubeId, key);
};

export function getTargetCubeAllData(cubeId: CubeId): FreeObjMap {
    return Utils.deepCopy(__allDataGet__(cubeId));
}

export function hasKey(cubeId: CubeId, key: string): boolean {
    return __hasKey__(cubeId, key);
}

export function has(cubeId: CubeId): boolean {
    return __hasCube__(cubeId);
}

export function depGet(cubeId: CubeId): DepMap {
    return __depGet__(cubeId);
}

export function allCube(): Array<CubeId> {
    return __allCube__();
}
